import React, {Component} from 'react';
import { config, ROLES, DISPATCH_ID,SERVICE_API } from '../libs/utils/Const';
import { connect } from "react-redux";
import packageJson from '../../package.json';
import './Footer.css';
global.appVersion = packageJson.version;

class Footer extends Component {
    getYear = () => {
        let today = new Date();
        return today.getFullYear() || '';
    };

    render() {
        const { configReducer: { history }, sessionReducer: { user }, sessionReducer } = this.props;
        return (
            <footer className="page-footer font-small pt-5" style={{backgroundColor: config.footer.backgroundColor}}>
                <div className="text-center text-md-left" style={{marginRight: 20 ,  marginBlock: -28}}>
                    <div className="row">
                        {/* Logo de FMB */}
                        <div className="col-md-3 text-center p-0">
                            <a href="http://fmbsolutions.mx/" target="_blank">
                                <img src={config.footer.power} className="img-fluid" width='100px'  />
                            </a>
                        </div>
                        <hr className="clearfix w-100 d-md-none" />
                        {/* Información de la empresa */}
                        <div className="col-md-1 p-0">
                            <h6 className="text-uppercase mb-4" style={{color: config.footer.textColor, fontSize: config.footer.fontSizeF}}>Empresa</h6>
                            <p className="p-yard">
                                <a>
                                    <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF , fontWeight:100, cursor:'auto'}}/* onClick={() => history.goAboutUs()}*/> Nosotros </span>
                                </a>
                            </p>
                            <p>
                                <a>
                                    <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF , fontWeight:100, cursor:'auto' }}/* onClick={() => history.goQuestions()}*/> Preguntas frecuentes</span>
                                </a>
                            </p>
                            <p className="p-yard">
                                <a>
                                    <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF , fontWeight:100, cursor:'auto' }} /*onClick={() => history.goContactUs()}*/> Contacto </span>
                                </a>
                            </p>
                            {/* {config.modules.BolsaTrabajo && 
                                <p>
                                    <a>
                                        <span style={{ color: config.footer.textColor }} onClick={() => history.goJob()}> Bolsa de trabajo </span>
                                    </a>
                                </p>
                            } */}
                            {/* {config.modules.Devoluciones && 
                                <p>
                                    <a>
                                        <span style={{ color: config.footer.textColor }} onClick={() => history.goDevolution()}> Devoluciones </span>
                                    </a>
                                </p>
                            }
                            <p>
                                <a>
                                    <span style={{ color: config.footer.textColor }} onClick={() => history.goNewsBlog()}> Blog de noticias </span>
                                </a>
                            </p> */}
                            {/* <p>
                                <a>
                                    <span style={{ color: config.footer.textColor }} onClick={() => history.goRedAliado()}> Aliados </span>
                                </a>
                            </p> */}
                            {/* <p>
                                <a>
                                    <span style={{ color: config.footer.textColor }} onClick={() => history.goQuestionshipping()}> Información de envío</span>
                                </a>
                            </p> */}
                        </div>
                        <hr className="clearfix w-100 d-md-none" />
                        {/* Logo de la empresa */}
                        <div className="col-md-4 text-center p-0" style = {{marginTop: '0%'}}>
                            <a /*href="" */ target="_blank">
                                <img src={config.footer.icon} className="img-fluid" width='276px' />
                            </a>
                            <p className="p-yard">
                                { config.footer.socialMedia2.map( (red, index) => {
                                    return(red.visibility &&
                                        <a class="btn btn-floating m-1" href={red.linkref} target="_black" key={index}>
                                            <img className="img-fluid" width='30px' src={red.icon}/>
                                        </a>
                                    )
                                })}
                            </p>
                        </div>
                        <hr className="clearfix w-100 d-md-none" />
                        {/* Información legal */}
                        <div className="col-md-2 p-0">
                            <h6 className=" text-uppercase mb-4" style={{color: config.footer.textColor, fontSize: config.footer.fontSizeF, cursor:'auto'}}>Legales</h6>
                            {config.pdf.VERterminosCondiciones &&
                                <p className="p-yard">
                                    {/* <a href={`${config.BASE_URL}/${SERVICE_API.getPolitics}/${config.pdf.terminosCondiciones}`} target="_blank" > */}
                                    <a target="_blank" >
                                        <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF, fontWeight:100, cursor:'auto' }}>Términos y condiciones </span>
                                    </a>
                                </p>
                            }
                            {config.pdf.VERpoliticasVentas &&
                                <p className="p-yard">
                                    {/* <a href={`${config.BASE_URL}/${SERVICE_API.getPolitics}/${config.pdf.politicasEnviosGarantias}`} target="_blank" > */}
                                    <a target="_blank" >    
                                        <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF, fontWeight:100, cursor:'auto'  }}>Políticas de envíos y garantías </span>
                                    </a>
                                </p>
                            }
                            {config.pdf.VERpoliticasGarantia &&
                                <p className="p-yard">
                                    {/* <a href={`${config.BASE_URL}/${SERVICE_API.getPolitics}/${config.pdf.politicasGarantia}`} target="_blank" > */}
                                    <a target="_blank" > 
                                        <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF, fontWeight:100, cursor:'auto'  }}> Políticas de garantía </span>
                                    </a>
                                </p>
                            }
                            {config.pdf.VERpoliticasUsoAvisoPrivacidad &&
                                <p className="p-yard">
                                    {/* <a href={`${config.BASE_URL}/${SERVICE_API.getPolitics}/${config.pdf.politicasUsoAvisoPrivacidad}`} target="_blank" > */}
                                    <a target="_blank" > 
                                        <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF, fontWeight:100,cursor:'auto'  }} > Políticas de uso y aviso de privacidad </span>
                                    </a>
                                </p>
                            }
                        </div>
                        <hr className="clearfix w-100 d-md-none" />
                        {/* Ubicaccion de la empresa */}
                        <div className="col-md-2 p-0">
                            <h6 className=" text-uppercase mb-4" style={{color: config.footer.textColor, fontSize: config.footer.fontSizeF}}>Contacto</h6>
                            <p className="p-yard">
                                <a>
                                    <img className="img-fluid" width='5%' height='5%' src={config.footer.info.hoursIcon} style={{ color: config.footer.iconColor, padding: 1 }}></img>&nbsp;
                                    <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF , fontWeight:100, cursor:'auto' }}>{config.footer.info.hours}</span>
                                </a>
                            </p>
                            <p >
                                <a>
                                    <img className="img-fluid" width='5%' height='5%' src={config.footer.info.phoneIcon} style={{ color: config.footer.iconColor, padding: 1 }}></img>&nbsp;
                                    <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF , fontWeight:100, cursor:'auto' }}>{config.footer.info.phone}</span>
                                </a>
                            </p>
                            <p>
                                <a href={"mailto:" + config.footer.info.email}>
                                    <img className="img-fluid" width='5%' height='5%' src={config.footer.info.emailIcon} style={{ color: config.footer.iconColor, padding: 1 }}></img>&nbsp;
                                    <span style={{ color: config.footer.textColor, fontSize: config.footer.fontSizeF , fontWeight:100, cursor:'auto' }}>{config.footer.info.email}</span>
                                </a>
                            </p>
                        </div>
                        <hr className="clearfix w-100 d-md-none"></hr>
                    </div>
                </div>
                {/* Inofrmacion de la version */}
                <div className="footer-copyright text-center py-4">
                    <a href="http://fmbsolutions.mx/" target="_blank">
                        <span style={{ color: config.footer.textColor , fontSize: config.footer.fontSizeF , fontWeight:100, cursor:'auto'}}>Todos los derechos reservados © {this.getYear()} &middot; Versión &middot; {global.appVersion}</span>
                    </a>
                </div>
            </footer>
        );
    }
}
const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setItemsSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SET_ITEMS, value }),
        setItemsFilterSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Footer);